var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcIn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.2948 5.35705H4.27928C3.50317 5.35705 3 4.83774 3 4.17948C3 3.50842 3.51805 3 4.30968 3C5.10066 3 5.58702 3.50714 5.60254 4.17756C5.60254 4.83582 5.10066 5.35705 4.2948 5.35705ZM14 13H11.5688V9.4846C11.5688 8.56445 11.1886 7.93629 10.3523 7.93629C9.71266 7.93629 9.35695 8.36018 9.19138 8.76871C9.13671 8.89782 9.1377 9.07161 9.13872 9.25073L9.13899 9.32388V13H6.73048C6.73048 13 6.76152 6.77281 6.73048 6.20676H9.13899V7.27291C9.28128 6.80675 10.0509 6.14145 11.2791 6.14145C12.8029 6.14145 14 7.11859 14 9.22271V13ZM5.42145 6.20676H3.27746V13H5.42145V6.20676Z",
    fill: "#949BA8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIn);
export default __webpack_public_path__ + "static/media/ic_in.8ec6d98766bfb645c023f8436e083be3.svg";
export { ForwardRef as ReactComponent };